export const languages: Record<string, string> = {
  English: "en",
  Japanese: "ja",
};
